export const measurements = {
  mobi: {
    headerHeight: '6rem',
    bottomTabsHeight: '5rem',
    maxWidth: '80rem',
    minWidth: '32rem',
  },
} as const
